<template>
  <v-dialog v-model="show" max-width="550px" persistent>
    <v-card>
      <v-card-title class="bg-deep-purple text-white d-flex align-center">
        <v-icon class="mr-2">mdi-shield-check</v-icon>
        Selecteaza Profil Limitari
        <v-spacer />
        <v-btn icon size="small" variant="text" color="white" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-progress-linear v-if="loadingProfiles" indeterminate color="deep-purple" class="mb-4" />

        <v-select
          v-model="selectedProfileId"
          :items="profileItems"
          item-title="title"
          item-value="value"
          label="Profil de limitari"
          variant="outlined"
          density="compact"
          :disabled="loadingProfiles"
          no-data-text="Nu exista profile disponibile"
        >
          <template v-slot:item="{ item, props: itemProps }">
            <v-list-item v-bind="itemProps">
              <template v-slot:append>
                <v-chip size="x-small" :color="item.raw.enabled ? 'success' : 'grey'" class="ml-2">
                  {{ item.raw.enabled ? 'Activ' : 'Inactiv' }}
                </v-chip>
                <v-chip size="x-small" color="info" variant="tonal" class="ml-1">
                  {{ item.raw.rulesCount }} reguli
                </v-chip>
              </template>
            </v-list-item>
          </template>
        </v-select>

        <v-alert v-if="errorMessage" type="error" density="compact" class="mt-2">{{ errorMessage }}</v-alert>
      </v-card-text>
      <v-card-actions class="pa-4 pt-0">
        <v-spacer />
        <v-btn variant="text" @click="close">Anuleaza</v-btn>
        <v-btn color="deep-purple" variant="elevated" :disabled="!selectedProfileId" @click="confirm">
          Asigneaza
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue'
import { getLimitationProfiles } from '@/composables/useTrafficAlertsAPI'
import store from '@/store'

export default defineComponent({
  name: 'SelectLimitationProfileDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    currentProfileId: { type: [Number, null], default: null }
  },
  emits: ['update:modelValue', 'select'],
  data() {
    return {
      selectedProfileId: null,
      profiles: [],
      loadingProfiles: false,
      errorMessage: ''
    }
  },
  computed: {
    show: {
      get() { return this.modelValue },
      set(val) { this.$emit('update:modelValue', val) }
    },
    token() { return store.getters.getToken },
    profileItems() {
      return this.profiles.map(p => ({
        title: `${p.name} (${p.rules_count} reguli)`,
        value: p.id,
        enabled: p.enabled,
        rulesCount: p.rules_count
      }))
    }
  },
  watch: {
    modelValue(val) {
      if (val) {
        this.selectedProfileId = this.currentProfileId
        this.errorMessage = ''
        this.loadProfiles()
      }
    }
  },
  methods: {
    async loadProfiles() {
      this.loadingProfiles = true
      try {
        const res = await getLimitationProfiles(this.token)
        if (!res.error) {
          this.profiles = res.profiles || []
        } else {
          this.errorMessage = res.message || 'Eroare la incarcarea profilelor'
        }
      } catch (err) {
        this.errorMessage = 'Eroare la incarcarea profilelor'
      } finally {
        this.loadingProfiles = false
      }
    },
    close() {
      this.show = false
    },
    confirm() {
      if (this.selectedProfileId) {
        this.$emit('select', this.selectedProfileId)
        this.close()
      }
    }
  }
})
</script>
